import { render } from "./UserDashboardView.vue?vue&type=template&id=ad2e41a4&scoped=true"
import script from "./UserDashboardView.vue?vue&type=script&lang=js"
export * from "./UserDashboardView.vue?vue&type=script&lang=js"

import "./UserDashboardView.vue?vue&type=style&index=0&id=ad2e41a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad2e41a4"]])

export default __exports__